module.exports = __webpack_public_path__ + "media/images/conical-flask-icon-7dc4cc83.svg";